import { window } from "@swa-ui/browser/window";
import { dateFormats, swaDate } from "@swa-ui/date";
import { createHrefWithSearchParams } from "@swa-ui/href/createHrefWithSearchParams";

import { FLIGHT_CAR, FLIGHT_HOTEL } from "../defines/packageType";

const AIRLINE_CODE = "WN";
const OJT_FARE_GROUP_CODE = "Getaway";

function base64EncodeString(string) {
  const toSolidBytes = (match, p1) => {
    const charCode = `0x${p1}`;

    return String.fromCharCode(charCode);
  };

  return window.btoa(encodeURIComponent(string).replace(/%([0-9A-F]{2})/g, toSolidBytes));
}

export const getOJTFormSubmitUrl = (baseUrl, originalFormData, searchParams = {}) => {
  const {
    departureDate,
    destinationAirportCode,
    inboundFlightNumbers,
    originationAirportCode,
    outboundFlightNumbers,
    packageType,
    promoCode,
    returnDate,
    travelers,
  } = originalFormData;
  const childrenAges = [];
  let adults = 0;
  let children = 0;
  let lapChildren = 0;

  travelers.forEach((room) => {
    adults += room.adults;
    children += room.children;
    lapChildren += room.lapChildren;

    room.childrenAge.forEach((age) => {
      childrenAges.push({ age });
    });
  });

  const processedFormData = {
    destination: {
      locationByCode: {
        code: destinationAirportCode,
        context: destinationAirportCode.length === 3 ? "IATA" : "LOCATION_ID",
      },
    },
    flight: {
      departureDate: swaDate(departureDate).format(dateFormats.iso),
      returnDate: swaDate(returnDate).format(dateFormats.iso),
    },
    origin: {
      locationByCode: {
        code: originationAirportCode,
        context: "IATA",
      },
    },
    passengerCounts: [
      {
        passengerType: "ADT",
        count: adults,
      },
      {
        passengerType: "CHD",
        count: children,
        passengerAges: childrenAges,
      },
      {
        passengerType: "INF",
        count: lapChildren,
      },
    ],
    promotionCode: promoCode,
  };

  if (packageType !== FLIGHT_CAR) {
    processedFormData.hotel = {
      rooms: [],
    };

    travelers.forEach((room) => {
      const newRoom = {
        adults: 0,
        children: [],
      };

      newRoom.adults = room.adults;

      room.childrenAge.forEach((age) => {
        newRoom.children.push({ age });
      });

      if (room.lapChildren) {
        newRoom.infants = room.lapChildren;
      }

      processedFormData.hotel.rooms.push(newRoom);
    });
  }

  if (packageType !== FLIGHT_HOTEL) {
    processedFormData.car = {};
  }

  if (outboundFlightNumbers && inboundFlightNumbers) {
    // Flight options are required in Switch Sell, so if the flight number arrays are empty,
    // we still want this array to be sent.
    const flightOptions = [];

    if (outboundFlightNumbers.length > 0 && inboundFlightNumbers.length > 0) {
      const outbound = {
        boundIndex: 1,
        fareGroupCode: OJT_FARE_GROUP_CODE,
        flightSegments: outboundFlightNumbers.map((flightNumber) => ({
          marketingAirline: {
            airlineCode: AIRLINE_CODE,
            flightNumber,
          },
        })),
      };
      const inbound = {
        boundIndex: 2,
        fareGroupCode: OJT_FARE_GROUP_CODE,
        flightSegments: inboundFlightNumbers.map((flightNumber) => ({
          marketingAirline: {
            airlineCode: AIRLINE_CODE,
            flightNumber,
          },
        })),
      };

      flightOptions.push(outbound, inbound);
    }

    processedFormData.flight.preferences = { flightOptions };
  }

  return createHrefWithSearchParams(`${baseUrl}/package/dl/results`, {
    productType: "package",
    search: base64EncodeString(JSON.stringify(processedFormData)),
    ...searchParams,
  }).href;
};
